import React from 'react';
import { Typography, Divider } from 'antd';
import { HeaderContainer, BodyContainer } from "../../../../base-react/components/Container";
import { useParams } from "react-router-dom";
import { _T } from '../../../../base-react/src/Localization';
import { TeamsToolbar } from './components/TeamsToolbar';
import { TeamClassList } from './components/TeamClassList';
import { useCompetition } from '../../../../base-react/hooks/Competition';
const { Title } = Typography;
export const Teams = () => {
    const { event_id, competition_id, team_id } = useParams();
    const [, , , , , canEdit] = useCompetition(competition_id);
    return (React.createElement(React.Fragment, null,
        React.createElement(HeaderContainer, null,
            React.createElement(Typography, null,
                React.createElement(Title, null, _T('team.title')))),
        React.createElement(BodyContainer, null,
            React.createElement(TeamsToolbar, { competition_id: competition_id, team_id: team_id, disabled: !canEdit }),
            React.createElement(Divider, null),
            React.createElement(TeamClassList, { event_id: event_id, competition_id: competition_id, disabled: !canEdit }))));
};
